module.exports = __webpack_public_path__ + "img/FrogiGo_full.2f33d9cf.png";